import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen bg-zinc-950 text-zinc-50 flex flex-col items-center justify-center px-6 text-center"
    >
      <p className="text-[11px] uppercase tracking-[0.3em] text-zinc-500 mb-6">
        Error · 404
      </p>
      <h1 className="font-serif text-6xl md:text-9xl leading-none">
        The reel <span className="italic text-zinc-400">jammed.</span>
      </h1>
      <p className="text-zinc-400 mt-8 max-w-lg">
        The page you were looking for has fallen out of the catalogue.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-12 inline-flex items-center gap-3 bg-white text-zinc-950 px-8 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-zinc-200 transition-colors"
      >
        Back to the index
      </Link>
    </main>
  );
}
